
Vue.filter('yesno', function(val) {
  return val ? 'Yes' : 'No';
});

Vue.filter('truncate', function(val, length, ending) {
	length = length == null ? 100 : length;
	ending = ending == null ? '...' : ending;
	
	if (val.length > length) {
		return val.substring(0, length - ending.length) + ending;
	}
		
	return val;
});

Vue.filter('slug', function(val) {
  return val.toString().toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
});

Vue.filter('formatDate', function(value) {
	if (value) {
		return moment(String(value)).format('LLL')
	}
	
	return value;
});

Vue.filter('clipAdverb', function(value) {
	return value.toString().toLowerCase().replace(/ly$/, '')
});
